import React from 'react';
import { Calendar, DollarSign, Users, AlertTriangle, Building2 } from 'lucide-react';

const CardBillingConfirmationDialog = ({
                                           isOpen,
                                           onConfirm,
                                           onCancel,
                                           billingData
                                       }) => {
    if (!isOpen) return null;

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-KE', {
            style: 'currency',
            currency: 'KES',
            minimumFractionDigits: 0
        }).format(amount);
    };

    return (
        <div
            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4"
            style={{ zIndex: 2000 }}
        >
            <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full overflow-hidden transform animate-in zoom-in-95 duration-200">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-6 text-white">
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                            <AlertTriangle className="w-6 h-6" />
                        </div>
                        <div>
                            <h3 className="text-xl font-bold">Billing Confirmation</h3>
                            <p className="text-blue-100">Review details before proceeding</p>
                        </div>
                    </div>
                </div>

                <div className="p-6">
                    <div className="bg-gray-50 rounded-xl p-4 mb-6">
                        <h4 className="font-semibold text-gray-900 mb-3">Billing Summary</h4>
                        <div className="grid grid-cols-2 gap-4 text-sm">
                            <div>
                                <p className="text-gray-600 flex items-center gap-2">
                                    <Building2 className="w-4 h-4" />
                                    Property
                                </p>
                                <p className="font-semibold">{billingData.propertyName}</p>
                            </div>
                            <div>
                                <p className="text-gray-600 flex items-center gap-2">
                                    <Calendar className="w-4 h-4" />
                                    Period
                                </p>
                                <p className="font-semibold">{billingData.month} {billingData.year}</p>
                            </div>
                            <div>
                                <p className="text-gray-600 flex items-center gap-2">
                                    <Users className="w-4 h-4" />
                                    Tenants
                                </p>
                                <p className="font-semibold">{billingData.tenantCount} units</p>
                            </div>
                           {/* <div>
                                <p className="text-gray-600 flex items-center gap-2">
                                    <DollarSign className="w-4 h-4" />
                                    Est. Total
                                </p>
                                <p className="font-semibold text-green-600">{formatCurrency(billingData.estimatedTotal)}</p>
                            </div>*/}
                        </div>
                    </div>

                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                        <div className="flex gap-3">
                            <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
                            <div className="text-sm">
                                <p className="font-medium text-yellow-800">Important Notice</p>
                                <p className="text-yellow-700">This will generate bills and send SMS notifications to all tenants. This action cannot be undone.</p>
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-3">
                        <button
                            onClick={onCancel}
                            className="flex-1 py-3 px-4 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            className="flex-1 py-3 px-4 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
                        >
                            Proceed with Billing
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardBillingConfirmationDialog;